export const ADDRESS_TYPES = {
  GAMEDAY: 'GAMEDAY',
  SAP: 'SAP'
};

export const ADDRESS_ID_TYPES = {
  [ADDRESS_TYPES.GAMEDAY]: 'id',
  [ADDRESS_TYPES.SAP]: 'shipToId'
};

export const getProductAddressInfo = address => {
  const addressType = address?.type && ADDRESS_TYPES[address.type] ? address.type : null;
  const addressId = addressType ? address[ADDRESS_ID_TYPES[addressType]] || null : null;

  return { addressType, addressId };
};

export const findProductAddress = (addresses, addressId, addressType) =>
  addresses.find(address => {
    const productAddressId = address[ADDRESS_ID_TYPES[addressType]];
    return productAddressId === addressId && address.type === addressType;
  }) || null;
